(function() {
    "use strict";

    angular.module("inetconsFilter", [])
        .directive("accofilterRoot", [
            "accosFilter",
            function(accosFilter) {
                return {
                    restrict: "A",
                    link: function($scope, $element) {
                        accosFilter.setRootElement($element);
                    }
                }
            }
        ])
        .directive("accofilterItem", [
            "accosFilter",
            function(accosFilter) {
                return {
                    restrict: "A",
                    link: function($scope, $element, $attr) {
                        var acco = angular.fromJson($attr.accofilterItem);
                        acco.item = $element;

                        accosFilter.addItem(acco);
                    }
                }
            }
        ])
        .factory("accosFilter", [
            function() {
                function FilterdAccos(filterdAccos) {
                    this.filterdAccos = filterdAccos;
                    this.length = function() {
                        return this.filterdAccos.length;
                    }
                    this.countByBoardingId = function(boardingId) {
                        var accos = this.filterdAccos;
                        var count = 0;
                        for (var i = 0; i < accos.length; i++) {
                            if (accos[i].boardingIds.indexOf(boardingId) != -1) {
                                count++;
                            }
                        }
                        return count;
                    },
                    this.countByAmenityId = function(amenityId) {
                        var accos = this.filterdAccos;
                        var count = 0;
                        for (var i = 0; i < accos.length; i++) {
                            if (accos[i].amenityIds.indexOf(amenityId) != -1) {
                                count++;
                            }
                        }
                        return count;
                    },
                    this.getElements = function () {
                        var accos = this.filterdAccos;
                        var elements = angular.element();
                        for (var i = 0; i < accos.length; i++) {
                            $.merge(elements, accos[i].item);
                        }
                        return elements;
                    }
                }

                return {
                    accos: [],
                    rootElement: null,

                    setRootElement: function(element) {
                        this.rootElement = element;
                    },
                    addItem: function(acco) {
                        this.accos.push(acco);
                    },


                    filterAll: function() {
                        var allElements = this._forEachAccoItem(function() { return true; });
                        return new FilterdAccos(allElements);
                    },
                    filterByIds: function(boardingIds, amenityIds) {
                        var filterdAccos = this._forEachAccoItem(function(acco) {
                            var boarding = true;
                            var amenity = true;
                            if (boardingIds.length) {
                                boarding = this._ArrayContainsOne(acco.boardingIds, boardingIds);
                            }

                            if (amenityIds.length) {
                                amenity = this._ArrayContainsAll(acco.amenityIds, amenityIds);
                            }

                            return boarding && amenity;
                        });
                        return new FilterdAccos(filterdAccos);
                    },


                    _forEachAccoItem: function(func) {
                        var filterdAccos = [];
                        angular.forEach(this.accos, function(acco) {
                            if (func.call(this, acco)) {
                                filterdAccos.push(acco);
                            }
                        }, this);
                        return filterdAccos;
                    },
                    _ArrayContainsAll: function(intArray1, intArray2) {
                        var matchs = 0;

                        for (var value1 in intArray1) {
                            if (intArray1.hasOwnProperty(value1)) {

                                for (var value2 in intArray2) {
                                    if (intArray2.hasOwnProperty(value2)) {
                                        if (intArray1[value1] == intArray2[value2]) {
                                            matchs++;
                                        }
                                    }
                                }

                            }
                        }

                        return matchs == intArray2.length;
                    },
                    _ArrayContainsOne: function(intArray1, intArray2) {
                        for (var value1 in intArray1) {
                            if (intArray1.hasOwnProperty(value1)) {

                                for (var value2 in intArray2) {
                                    if (intArray2.hasOwnProperty(value2)) {
                                        if (intArray1[value1] == intArray2[value2]) {
                                            return true;
                                        }
                                    }
                                }

                            }
                        }

                        return false;
                    }
                };
            }
        ])
        .factory("shuffle", [
            "cookie",
            function (cookie) {

                function shuffle(arr, m) {
                    for (var j, x, i = arr.length; i; j = parseInt(m.random() * i), x = arr[--i], arr[i] = arr[j], arr[j] = x);
                    return arr;
                };

                return function(rootElement, elements) {

                    var seed = (function() {
                        var seed = cookie.get("seed");
                        if (seed == null) {
                            seed = parseInt(Math.random() * 10000);
                            cookie.set("seed", seed);
                        }
                        return seed;
                    })();

                    var m = new MersenneTwister(seed);

                    var tophotels = elements.filter('.top');
                    tophotels = shuffle(tophotels, m);

                    var normal = elements.not('.top').not('.testclient-20').not('.testclient-0');
                    normal = shuffle(normal, m);

                    var testclients20 = elements.filter('.testclient-20');
                    testclients20 = shuffle(testclients20, m);

                    var testclients = elements.filter('.testclient-0');
                    testclients = shuffle(testclients, m);

                    var merged = $.merge($.merge($.merge(tophotels, normal), testclients20), testclients);

                    rootElement.html(merged);

                    if (typeof BindGaTracking === "function") {
                        BindGaTracking(); // site.js
                    }
                }
            }
        ]);


})();
